import { getHttpClient } from '../../../../shared/utils/http-client.ts';
import { Paragraph } from '../models/paragraph';
import { updateParagraphEndpoint } from './const';

export const updateParagraph = (paragraph: Paragraph) => {
    return getHttpClient().post({ url: updateParagraphEndpoint, data: JSON.stringify(paragraph) });
};
